import { faCaretRight } from '@fortawesome/pro-solid-svg-icons'
import { Flex, Text, type TextProps } from '@mantine/core'
import { type ReactNode } from 'react'

import { Icon } from '../Icon/Icon'

export type TextCategoryBreadcrumbStringProps = TextProps & {
  categories?: string
  separator?: ReactNode
}

export function TextCategoryBreadcrumbString({
  categories,
  separator = <Icon icon={faCaretRight} data-testid='separator' />,
  c = 'dimmed',
  ...props
}: TextCategoryBreadcrumbStringProps) {
  if (!categories) {
    return null
  }

  return (
    <Text c={c} {...props}>
      <Flex align='center' gap='xs'>
        {categories.split(' > ').map((category, index) => (
          <>
            {category}
            {index < categories.split(' > ').length - 1 && separator}
          </>
        ))}
      </Flex>
    </Text>
  )
}
